/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-len */
import NewYHConstract from '@/mixins/constracts';
import { Component, Mixins } from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'HSContract' })
export default class HSContract extends Mixins(NewYHConstract) {
  private render() {
    const {
      funderName,
      userName,
      contractNo,
      idCard,
      effectiveDate,
    } = this.constractForms;
    return (
      <div class={style.HSContract}>
        <p>合同编号：{contractNo}</p>
        <p><strong>恒生银行（中国）有限公司个人借款授信额度合同</strong></p>
        <p><strong>敬请注意</strong></p>
        <p>
        为了维护您的合法权益，请在签署本合同之前，仔细阅读以下注意事项：<br />
        1、您已经阅读并接受本合同的所有条款，并知悉其含义；<br />
        2、您确认向银行所作的陈述是真实、合法、完整和有效的；<br />
        3、您已经确认在“臻有钱”贷款服务平台点击接受本合同，即意味着已阅读本合同所有条款，并对本合同条款的含义及相应的法律后果已全部通晓并充分理解，同意作为受信人接受本合同约束。<br />
        4、您确认或接受本合同后本合同立即生效，但通过本行审核通过后才获得有效额度。受信人可使用的授信额度类型为循环额度。<br />
          具体额度以本行审批结果为准。您应在授信额度批准后的一个月内完成首笔贷款提款，否则授信额度将自动失效。您的每笔提款申请，<br />
          本行仍将根据您的最新信用状况等因素综合判断后再决定是否予以核准通过。您的授信额度自批准后每十二个月将进行重新审批，<br />
          本行有权根据重新审批时的市场情况、您的资信情况等因素重新厘定您的额度与利率水平。<br />
        5、您确认并接受，无论申请是否成功，本行不受本合同有效期限制并有权决定给予的贷款服务或额度并非构成本行必须履行发放贷款的义务。您使用服务或额度，仍需要经过逐笔申请及本行审批和同意。<br />
        6、您确认并同意本行有权通过其他合法途径了解、核实有关您本人的信息和数据。<br />
        7、如果您对本合同还有疑问之处，您可以通过<strong>“臻有钱”在线客服或恒生银行（中国）有限公司电话客服4008-30-8008</strong>了解本合同项下个人消费贷款业务。<br />
        </p>
        <br />
        <p><strong>个人借款授信额度合同</strong></p>
        <p>
        立约人：<br />
        受信人：见本合同第二十三条。<br />
        本行：见本合同第二十三条。<br />
        </p>
        <p>
        目录<br />
        第一章 总则<br />
        第二章 授信额度和授信期限<br />
        第三章 提款<br />
        第四章 主要权利和义务<br />
        第五章 违约责任<br />
        第六章 其他约定事项<br />
        第七章 特别签约条款<br />
        </p>
        <p>
        <strong>第一章 总则</strong><br />
        <strong>第一条 签订依据</strong><br />
        依据《中华人民共和国民法典》、《个人贷款管理暂行办法》等法律、法规、金融监管规定和本行相关规章制度的规定，合同双方经协商一致，特立本合同。<br />
        </p>
        <p>
        <strong>第二条 定义</strong><br />
        个人信用消费贷款授信业务，是指受信人向本行提出授信申请，本行经审核同意给予受信人在约定期限内的授信额度，受信人可在此额度内提款用于其本人消费用途的业务模式。<br />
        </p>
        <p>
        <strong>第二章 授信额度和授信期限</strong><br />
        </p>
        <p>
        <strong>第三条 授信额度</strong><br />
        循环额度是指本行在授信有效期间根据本合同为受信人提供的循环使用的所有贷款本金余额的最高限额。<br />
        循环额度＝合同项下未清偿的贷款余额+可使用额度受信人可使用的授信额度见本合同第二十四条。授信额度由本行一次性核定。<br />
        </p>
        <p>
        <strong>第四条 授信用途</strong><br />
        受信人使用该授信额度，用于合法、合规的消费用途，具体用途见本合同第二十五条。<br />
        <strong>第五条 授信期限</strong><br />
        授信期限是指本行给予受信人相应授信额度贷款的有效期间。若本行审核通过的，受信人应在授信期限和授信额度内，向本行申请贷款。<br />
        对于受信人在授信期限和授信额度提出的每次申请，本行有权根据审批规则自主决定是否给予发放贷款。授信期限见本合同第二十六条。<br />
        <strong>第六条 贷款到期日</strong><br />
        贷款到期日是指本行给予受信人相应授信额度内发放的具体每笔贷款的贷款到期日。<br />
        </p>
        <p>
        <strong>第三章 提款</strong><br />
        <strong>第七条 受信人提款先决条件</strong><br />
        1、未出现或未可能出现本合同约定的违约情形；<br />
        2、提款金额不超过本合同中约定的授信额度；<br />
        3、在授信额度有效期限内提款；<br />
        4、单笔申请金额不低于人民币壹元；<br />
        5、提款用途符合本合同约定；<br />
        6、贷款资金支付方式符合监管部门及本行的相关规定；<br />
        7、受信人信用状况未恶化或未出现可能恶化的情形；<br />
        8、达到本行要求的其他条件。<br />
        </p>
        <p>
        <strong>第八条 提款程序</strong><br />
        受信人每次提款前，须提前通过“臻有钱”贷款服务平台与本行签署《个人消费贷款合同》。受信人通过“臻有钱”贷款服务平台提交的提款申请，<br />
        经本行审核同意后，根据上述《个人消费贷款合同》约定的支付方式将贷款资金划至约定的账户。<br />
        </p>
        <p>
        <strong>第四章 主要权利和义务</strong><br />
        <strong>第九条 受信人承诺</strong><br />
        1、是具有完全民事行为能力的自然人，具有签订和履行本合同的能力和资格。<br />
        2、已充分了解本合同及其它相关文件的全部内容。 <br />
        3、向本行提交的所有证明、文件等资料都是真实、合法、完整、有效的。<br />
        4、签订和履行本合同，与其签订和履行其他任何合同均无抵触。<br />
        5、未有严重疾病、重大债务、涉及调解、仲裁、诉讼、索赔、强制执行和可能危及本行权益的其他事件。<br />
        </p>
        <p>
        <strong>第十条 受信人的主要权利</strong><br />
        1、有权依本合同的约定获得贷款。<br />
        2、有权向本行了解、咨询、知悉个人信用消费贷款业务有关事项。<br />
        </p>
        <p>
        <strong>第十一条 受信人的主要义务</strong><br />
        1、按本合同的约定履行还款义务。受信人不得以未收到本行寄送的对账单、联系单、还款计划、还款短信或与第三方发生纠纷等任何理由不履行本合同约定的还款义务。<br />
        2、贷款用途符合国家法律法规及有关政策规定，并按合同约定的用途使用贷款，不得挪用贷款。<br />
        3、如实向本行提供申请授信所需的各种资料，包括婚姻状况证明、收入证明、个人所得税税单、存款证明、扶（抚）养人情况证明等，并保证所提供的所有资料均为真实、有效、完整。<br />
        4、配合本行对其信用状况进行调查。<br />
        5、不得隐瞒本人负有重大债务等可能危及本行债权的其他情形。<br />
        6、住所地、现住地址、联系方式、工作单位、单位地址、职务、单位业务性质等个人基本情况发生变化时，应于变更事件发生的十日内书面通知本行。<br />
        7、配合本行检查、监督借款使用情况、收入状况、对外担保等情况，并配合提供有关资料。<br />
        8、除有关部门另有规定外，受信人应根据法律法规规定及本合同约定承担本合同项下的相关费用和税费。<br />
        </p>
        <p>
        <strong>第十二条 本行的主要权利</strong><br />
        1、有权对受信人提供的资料、文件的合法性、真实性进行调查。<br />
        2、有权检查贷款的使用情况。<br />
        </p>
        <p>
        <strong>第十三条 本行的主要义务</strong><br />
        1、按本合同的约定发放贷款。<br />
        2、对未获批准的提款申请，本行应及时告知受信人。<br />
        </p>
        <p>
        <strong>第五章违约责任</strong><br />
        <strong>第十四条 违约情形</strong><br />
        受信人发生下列情形之一的，即构成违约：<br />
        受信人虚构贷款用途；<br />
        2、受信人违反本合同约定挪用贷款资金；<br />
        3、贷款期间（包括贷款提前到期），受信人未按照本合同约定按时归还贷款本息或其他应付款项的（包括贷款逾期后受信人已归还逾期本息或由担保人（若有）代其履行的情形）；<br />
        4、受信人向本行提交的有关证明和文件或其所作出的任何声明、保证和承诺为不真实、不准确、不完整或存在虚假记载、误导性陈述或者重大遗漏等； <br />
        5、受信人申请借款时隐瞒本人或其家庭成员存在严重疾病，或负有重大债务，或涉及调解、仲裁、诉讼、索赔、强制执行及其他严重影响其还款能力的情形（一项或多项）；<br />
        6、受信人死亡或被宣告死亡而其财产合法继承人不继续履行本合同的，或受信人被宣告失踪而其财产代管人不继续履行本合同的，受信人丧失民事行为能力而其监护人不继续履行本合同的；<br />
        7、受信人发生因不能履行本合同义务之资信状况恶化、疾病、事故、死亡或还贷<br />
        能力出现其他重大变化（包括但不限于国籍变更或迁往境外、住所地变更、婚姻情况变动、家庭财务状况恶化、收入降低、失业、重大疾病、拖欠其他债务等）等；<br />
        8、受信人卷入或即将卷入民事诉讼、仲裁、索赔或其他法律纠纷，或被强制执行，或受到行政或刑事处罚，或被国家行政或司法机关宣布对其财产没收或对其处分权的限制，或存在该种情况发生可能的威胁； <br />
        9、受信人低价转让、无偿转让或隐藏财产、减免第三方债务、怠于行使债权或其他权利，本行认为可能危及本合同项下债权安全的； <br />
        10、受信人未履行对本行负有的其他到期债务，或本行发现受信人有其他拖欠债务的行为的； <br />
        11、受信人发生其他足以对其偿还债务能力造成不利影响的事件，或受信人明确表示或以其行为表明将不履行本合同项下的义务； <br />
        12、受信人拒绝本行对其使用借款情况和收入状况、对外担保等情况进行检查监督，拒绝提供有关资料，或提供虚假材料的； <br />
        13、受信人违背本合同所作的任何一项承诺的； <br />
        14、受信人违反本合同其他约定的。 <br />
        </p>
        <p>
        <strong>第十五条 本行可采取的措施 </strong><br />
        受信人违约的，本行或其代理方有权采取下列一种或数种措施：<br />
        1、冻结受信人尚未使用的授信额度；<br />
        2、减少、取消或终止受信人尚未使用的授信额度和授信期限；<br />
        3、要求受信人按本行的要求变更贷款支付方式；<br />
        4、宣布所有贷款到期，提前收回已发放的贷款本息；<br />
        5、按违约天数、金额计收贷款逾期、贷款挪用的罚息；<br />
        6、要求受信人对本合同项下所有债务提供符合本行要求的新的担保；<br />
        7、提前解除本合同；<br />
        8、要求受信人限期纠正违约行为并赔偿相应损失；<br />
        9、委托第三方或通过任何公众媒体发布公告等方式进行催收或追偿；<br />
        10、向人民法院起诉，采取查封、冻结、扣划等资产保全措施；<br />
        11、向受信人收取本行为实现债权的所有相关费用；<br />
        12、本行认为应当采取的其他措施。<br />
        本行采取上述措施无需征得受信人的同意，相关决定一经作出，随即生效；本行只限于通过《个人借款合同》约定的通讯地址通知受信人，但本行无义务必须通知受信人；<br />
        无论何种原因造成通知不及时、通知未达或无法通知等情形的，不影响本行决定的有效性，本行也不因此承担任何法律责任。因授信额度减少，导致本合同项下贷款余额大于最高贷款限额时，<br />
        受信人的实际债务以本合同项下的未清偿债务为准。<br />
        </p>
        <p>
        <strong>第十六条 合同解除或终止</strong><br />
        出现下列任一情形时，本行有权解除或终止合同并要求受信人归还贷款本息和其他应付款项。<br />
        1、受信人未按合同约定履行还款义务；<br />
        2、受信人未按本合同约定归还积欠贷款本息的；<br />
        3、受信人申请授信时提供虚假的收入、婚姻状况、家庭状况、个人资产等证明材料、扶（抚）养人情况说明等；<br />
        4、受信人申请授信时隐瞒本人存在严重疾病、负有重大债务、涉及调解、仲裁、诉讼、索赔、强制执行及其他严重影响其还款能力的情形；<br />
        5、受信人死亡或被宣告死亡或被宣告失踪而无人代其履行债务的；<br />
        6、受信人发生不能履行本合同义务的个人信用状况恶化、疾病、事故等事件；<br />
        7、受信人卷入民事纠纷，影响或可能影响其在本合同项下债务履行；或受信人触犯刑律，可能被处拘役以上刑罚，或由国家行政或司法机关宣布对其财产予以没收或限制其处分的，或存在上述情况发生可能的危险的； <br />
        8、受信人违反本合同其他约定，影响本行债权实现的。 <br />
        9、在本合同有效期间，因法律、法规或监管规定的变化而致使本合同无效或违反监管相关规定。<br />
        </p>
        <p>
          <strong>第六章 其他约定事项</strong>
        </p>
        <p>
        <strong>第十七条争议解决</strong><br />
        合同各方在履行合同过程中发生争议的，可以协商解决，也可以直接向本行所在地、被告住所地或合同签订地的人民法院提起诉讼。在协商或诉讼期间，本合同不涉及争议部分的条款仍须履行。<br />
        <strong>第十八条合同构成 </strong><br />
        本合同由本合同条款、受信人在贷款平台信息系统填写的所有信息以及贷款平台各项规则以及与本贷款相关的《个人消费贷款合同》、《授信额度合同》、《个人信用报告查询授权书》组成，各组成部分均具有法律效力。<br />
        </p>
        <p>
        <strong>第十九条合同变更、补充</strong><br />
        1、本行有权对合同内任何条款进行变更或补充其他未尽事宜，受信人对此表示认可，如受信人在合同变更或补充后仍继续接受本行通过合作方提供的贷款服务的，则视为受信人接受对本合同的变更或补充，应遵循相关条款的约束。<br />
        2、变更或补充内容与本合同具有同等法律效力。<br />
        </p>
        <p>
        <strong>第二十条合同形式及生效</strong><br />
        本行与受信人一致本同意以数据电文形式订立并认同其效力。<br />
        受信人在“臻有钱”平台确认本合同后本合同立即生效，经过本行审核通过后额度生效。<br />
        </p>
        <p>
          <strong>第二十一条未尽事宜</strong><br />
          本合同未尽事宜按国家有关法律、法规、金融监管规定执行。<br />
        </p>
        <p>
        <strong>第二十二条 其他事项 </strong><br />
        本行在本合同项下的权利并不影响和排除其根据法律、法规和其它合同所享有的任何权利。授信 人任何对违约或延误行为施以任何宽容、宽限、优惠或延缓行使本合同项下的任何权利，<br />
        均不能视 为对本合同项下权利、权益的放弃或对任何违反本合同行为的许可或认可，也不限制、阻止和妨碍 本行对该权利的继续行使或对其任何其它权利的行使。<br />
        </p>
        <p>
          <strong>第七章 特别签约条款</strong><br />
        </p>
        <p>
        <strong>第二十三条 对立约人的说明</strong><br />
        本合同的立约人为：<br />
        受信人：<br />
        姓名：{userName} <br />
        证件号码：{idCard} <br />
        证件类型：身份证 <br />
        本行：{funderName} <br />
        <strong>第二十四条授信额度</strong> <br />
        受信人可使用的授信额度类型为循环额度。具体额度以本行审批结果为准。本行有权每年将根据受信人的情况进行重新审批并更新授信额度。<br />
        <strong>第二十五条授信用途</strong><br />
        受信人的授信额度具体用于：本人的日常消费。<br />
        本合同授信额度内每笔借款的具体用途详见受信人向本行提交的《个人消费贷款合同》。<br />
        受信人承诺严格按本合同约定的用途使用贷款， <strong>贷款用途：本贷款类型为个人消费贷款，包括但不限于以下中国境内消费目的：
        1)手机数码；2)旅游；3)装修；4)教育；5）婚庆6)租房；7)家具家居；8)健康医疗；9)家用电器；10)其他消费等。
        严禁贷款资金用于支付购房首付款或偿还首付款借贷资金，或其他流入房市的情形；严禁贷款资金流入股市、债市、金市、期市等交易市场；
        严禁贷款资金用于购买银行理财、信托计划、代销产品、结构性存款、金融衍生品及其他各类资产管理产品；
        严禁贷款资金用于民间借贷、P2P网络借贷以及其他禁止性领域等；
        严禁将贷款用于企业生产经营或其他与法律法规相冲突的用途。借款人也不得将贷款用于境外消费支出。
        此处所指境外，包括香港特别行政区、澳门特别行政区以及台湾地区。</strong>
        </p>
        <p>
          <strong>第二十六条 授信期限</strong><br />
          本合同项下的授信期限为【一年】，具体授信期限起始日和到期日以“臻有钱”贷款服务平台显示的为准。<br />
        </p>
        <p>
        <strong>第二十七条 其它约定</strong><br />
        受信人贷款利率、提款及贷款资金支付和扣款与还款、罚息等有关约定详见后续签署的《个人消费贷款合同》。<br />
        </p>
        <p>
        <strong>第二十八条 特别提示</strong><br />
        <strong>1、在签署本合同时，受信人对合同的全部条款均无疑义，并对合同各方有关权利义务和责任限制或免除条款的法律含义有准确无误的理解；</strong><br />
        <strong>2、本合同项下本行向受信人所收取的利息（含罚息、复利等）、违约金及其他费用等均为含税费用，包括但不限于增值税等相关税费；</strong><br />
        <strong>3、受信人对于本合同加粗加黑的内容及本行每十二个月将根据受信人情况进行重新审批并更新授信额度已充分理解掌握并放弃争议抗辩权。</strong><br />
        </p>
        <p>
        （以下无正文）<br />
        </p>
        <p>
          借款人：{userName} <br />
          日期：{effectiveDate} <br />
          电子签名：<br />
        </p>
        <br />
        <p>
        贷款人：{funderName} <br />
        日期：{effectiveDate} <br />
        电子签名：
        </p>
      </div>
    );
  }
}
